document.addEventListener("DOMContentLoaded", () => {
	// ── Scroll animations ─────────────────────────────────────────────────────
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	if (!prefersReducedMotion) {
		import("../../../assets/js/gsap.js").then(({ gsap, ScrollTrigger }) => {
			document.querySelectorAll(".timeline-event").forEach((event) => {
				gsap.set(event, { opacity: 0, x: -60 });

				ScrollTrigger.create({
					trigger: event,
					start: "top 80%",
					once: true,
					onEnter: () => {
						gsap.to(event, {
							opacity: 1,
							x: 0,
							duration: 0.75,
							ease: "sine.inOut",
						});
					},
				});
			});
		});
	}

	// ── Video modal ───────────────────────────────────────────────────────────
	const modal    = document.getElementById("video-modal");
	if (!modal) return;

	const iframe   = document.getElementById("video-modal-iframe");
	const closeBtn = modal.querySelector(".video-modal-close");
	const backdrop = modal.querySelector(".video-modal-backdrop");
	let   lastFocus = null;

	// All focusable elements inside the modal for focus trapping
	const getFocusable = () =>
		Array.from(modal.querySelectorAll(
			'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
		)).filter(el => !el.closest('[aria-hidden="true"]'));

	function openModal(videoId) {
		lastFocus = document.activeElement;
		iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&enablejsapi=1`;
		modal.setAttribute("aria-hidden", "false");
		modal.classList.add("is-open");
		document.body.style.overflow = "hidden";
		// Delay focus so the iframe is rendered
		requestAnimationFrame(() => closeBtn.focus());
	}

	function closeModal() {
		// Stop YouTube playback via postMessage before clearing src
		try {
			iframe.contentWindow.postMessage(
				JSON.stringify({ event: "command", func: "stopVideo", args: [] }),
				"https://www.youtube.com"
			);
		} catch (_) {}
		iframe.src = "";
		modal.setAttribute("aria-hidden", "true");
		modal.classList.remove("is-open");
		document.body.style.overflow = "";
		if (lastFocus) lastFocus.focus();
	}

	// Trigger buttons
	document.querySelectorAll(".video-modal-trigger").forEach((btn) => {
		btn.addEventListener("click", () => openModal(btn.dataset.videoId));
	});

	// Close on button / backdrop click
	closeBtn.addEventListener("click", closeModal);
	backdrop.addEventListener("click", closeModal);

	// Close on Escape
	modal.addEventListener("keydown", (e) => {
		if (e.key === "Escape") {
			closeModal();
			return;
		}

		// Focus trap
		if (e.key !== "Tab") return;
		const focusable = getFocusable();
		if (!focusable.length) return;
		const first = focusable[0];
		const last  = focusable[focusable.length - 1];

		if (e.shiftKey && document.activeElement === first) {
			e.preventDefault();
			last.focus();
		} else if (!e.shiftKey && document.activeElement === last) {
			e.preventDefault();
			first.focus();
		}
	});
});
